export const getDefaultDraggableScale = () => {
  return {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1,
  };
};
